import { Box, IconButton, Typography } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";

interface HeaderProps {
  field: string;
  sortField: string;
  headerName: string | undefined;
  showFilter: boolean;
  width?: number;
  onFilterSubmit: (value: any) => void;
}

export default function TableHeaderDatePicker({
  field,
  sortField,
  headerName,
  showFilter,
  width,
  onFilterSubmit,
}: HeaderProps) {
  const [value, setValue] = useState<Dayjs | null>(null);
  const [sort, setSort] = useState("asc");

  const toggleSorting = () => {
    onFilterSubmit({ sortColumn: sortField, sortOrder: sort });
    setSort(sort === "asc" ? "desc" : "asc");
  };

  const onDateChange = (date: Dayjs | null) => {
    setValue(date);
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    if (dayjs(formattedDate).isValid())
      onFilterSubmit({ [field]: formattedDate });
    else onFilterSubmit({ [field]: "" });
  };

  return (
    <Box sx={{ width, pr: 1 }}>
      <Box className="header" sx={{ display: "flex", alignItems: "center" }}>
        <Typography sx={{ fontWeight: "bold" }}>{headerName}</Typography>
        <IconButton aria-label="sort" onClick={toggleSorting}>
          {sort === "asc" ? (
            <ArrowUpwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          ) : (
            <ArrowDownwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          )}
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "auto",
          height: "auto",
          display: showFilter ? "block" : "none",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            sx={{
              width: width ? width - 30 : 170,
              height: 40,
              mt: 1,
              "& .MuiInputBase-root": {
                "& .MuiInputBase-input": {
                  padding: 1,
                },
              },
            }}
            value={value}
            onChange={(date) => onDateChange(date)}
          />
        </LocalizationProvider>
      </Box>
    </Box>
  );
}
